import { useMarketDataCardMarketSelectorItems } from '@src/components/MarketDataCard/useMarketDataCardMarketSelectorItems';
import type { MarketSelectorItem } from '@src/components/MarketSelector/types';
import { EMPTY_ARRAY, type MarketAccount, type Security } from '@talos/kyoko';
import { useMemo } from 'react';

import { useBuildMarketSelectorItems } from '../../MarketSelector/utils/useBuildMarketSelectorItems';

/**
 * Uses standard MSS-aware market-data items for a selected outcome. Event-only
 * cards have no security to query, so they expose the active accounts for the
 * selected venue instead.
 */
export function usePredictionMarketDataCardMarketSelectorItems({
  outcome,
  market,
  marketAccounts,
}: {
  outcome: Security | undefined;
  market: string | undefined;
  marketAccounts: MarketAccount[];
}): MarketSelectorItem[] {
  const outcomeItems = useMarketDataCardMarketSelectorItems({
    symbol: outcome?.Symbol,
  });
  const eventItems = useBuildMarketSelectorItems({
    marketAccounts,
    conditions: EMPTY_ARRAY,
    readyToBuildItems: true,
  });

  return useMemo(() => {
    const items = outcome ? outcomeItems : eventItems;
    return market ? items.filter(item => item.market.Name === market) : items;
  }, [eventItems, market, outcome, outcomeItems]);
}
